import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioEnviarPin } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

const EnviarPin = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (email.trim() === "") {
        mostraAlerta("Complete los campos", "warning");
        return;
      }
      const response = await AxiosPublico.post(UsuarioEnviarPin, {
        correo: email.trim(),
      });
      if (response.data && response.data.correo) {
        mostraAlerta(
          "Se ha enviado un pin a su correo " + response.data.correo,
          "success"
        );
        setTimeout(
          () =>
            navigate("/actualizar-contrasena", {
              state: { correo: response.data.correo },
            }),
          2000
        );
      } else {
        mostraAlerta("Se ha enviado un pin a su correo", "success");
        setTimeout(
          () =>
            navigate("/actualizar-contrasena", {
              state: { correo: email.trim() },
            }),
          2000
        );
      }
    } catch (error) {
      console.log("Error:", error);
      if (error.response) {
        console.log("Error Response Data:", error.response.data);
        if (Array.isArray(error.response.data)) {
          error.response.data.forEach((f) => {
            mostraAlerta("Campo: " + f.path + ". " + f.msg, "warning");
          });
        } else if (error.response.data.error) {
          mostraAlerta(error.response.data.error, "warning");
        } else {
          mostraAlerta("Error al enviar el PIN", "error");
        }
      } else {
        mostraAlerta("Error de red o servidor no disponible", "error");
      }
    }
  };

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
      <div className="login-logo" style={{display:'flex', justifyContent:'center'}}>
          {/* Agrega aquí el logotipo de tu aplicación */}
          <img
              src={NegocioConfig.logo}
              alt="SIGVEM LOGO"
              className="img-fluid img-circle" style={{ width: '250px', height: '250px' }}
            />
        </div>
        <div className="card card-outline">
          <div className="card-body">
            <h4 className="login-box-msg">Recuperar PIN</h4>
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Correo electrónico"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block btn-lg"
                  >
                    Enviar PIN
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="text-center mt-3">
          <Link to="/login" className="font-password text-primary">
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EnviarPin;
